import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Routes from "./Routes";
import withProvider from "./HOCs/WithProvider";

class App extends Component {
  render() {
    return (
      <Router>
        <Routes />
      </Router>
    );
  }
}

export default withProvider(App);



// WEBPACK FOOTER //
// ./src/App.js